import config from "../config";
import { AutomaticBackupSetting, ConfigAndPreferenceBackupEntry } from "../Model/Backup";
import {
    sendGetRequest,
    sendPutRequest,
    sendPostRequest,
    sendDownloadZip,
    sendDeleteRequest,
    concatOptionalParameter,
    encodeURISpecialCharacter,
  } from "../Utility/FetchUtils";
  import DateUtil from "../Utility/DateUtil";

export default class SystemBackupApi {
    static BASE_URL = config.SERVICE_URL + "/BackupConfiguration/";
    
    static getBackupList(
        startDate?: Date,
        endDate?: Date
      ): Promise<ConfigAndPreferenceBackupEntry[]> {
        let url;
        if ((startDate === null || startDate== undefined)&&( endDate=== null || endDate===undefined)){
          url =this.BASE_URL +
          `:backup-list`
        }else{
          if (startDate === null || startDate== undefined){
            startDate = new Date("2023-01-01");
          }
          if ( endDate=== null || endDate===undefined){
            endDate = new Date(Date.now());
          }
          url =this.BASE_URL +
          `:backup-list/${DateUtil.toString(startDate)}/${DateUtil.toString(endDate)}`
        }
        
          
    
        return sendGetRequest(url);
      }
    
    static backup(name?:string) {
      let url = this.BASE_URL + ":backup";
      url=concatOptionalParameter(url,{ "backupName":encodeURISpecialCharacter(name)})
      console.log ("url",url)
      return sendPostRequest(url);
    }

    static restore(backupId: number) {
      let url = this.BASE_URL + `:restore/${backupId}`;
      return sendPostRequest(url);
    }
    static getSetting(){
      const url = this.BASE_URL + ":setting";
      return sendGetRequest<AutomaticBackupSetting>(url);
    }
    static setSetting(backupSetting:AutomaticBackupSetting){
      const url = this.BASE_URL + ":setting";
      return sendPutRequest(url,backupSetting);
    }
    static download(backupIds:number[]){
      let url = this.BASE_URL + ":download";
      url=concatOptionalParameter(url,{ "selectedID":backupIds})
      return sendDownloadZip(url,"Backup.zip");
    }
    static delete(backupIds:number[]){
      let url = this.BASE_URL + `:delete`;
      url=concatOptionalParameter(url,{ "selectedID":backupIds})
      return sendDeleteRequest(url,backupIds);
    }
    
}